module.exports = __webpack_public_path__ + "static/media/itdog.3cced699.png";